﻿import config from "../config"

export default {
    list: {
        url: config.base_url + "adm_region/",
        type: "post",
    },
    save: {
        url: config.base_url + "adm_region/save",
        type: "post",
    },
    saveAll: {
        url: config.base_url + "adm_region/saveAll",
        type: "post",
    },
    remove:{
        url: config.base_url + "adm_region/delete/{id}",
        type: "post",
    },
    listBySpeciesId:{
        url: config.base_url + "species_item/listBySpeciesId",
        type: "get",
    },
}

